function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  clipRule: "evenodd",
  d: "M12.788 5.008a1 1 0 00-1.576 0l-2.95 3.776A1 1 0 009.05 10.4h5.9a1 1 0 00.787-1.616l-2.95-3.776zm-1.576 13.983a1 1 0 001.577 0l2.949-3.776a1 1 0 00-.788-1.615h-5.9a1 1 0 00-.787 1.615l2.95 3.776z"
})));